var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(24 24) rotate(-180)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.023 13C19.2851 12.9968 19.5353 12.8897 19.7185 12.7022C19.9017 12.5147 20.0029 12.2621 20 12C20 11.449 19.563 11 19.023 11L7.977 11C7.71495 11.0034 7.46496 11.1106 7.28182 11.2981C7.09867 11.4855 6.99733 11.7379 7 12C6.99733 12.2621 7.09867 12.5145 7.28182 12.7019C7.46496 12.8894 7.71495 12.9966 7.977 13L19.023 13Z",
    fill: "#D13D3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.769 15.694L20.699 12.738C20.8922 12.541 21.0005 12.276 21.0005 12C21.0005 11.724 20.8922 11.459 20.699 11.262L17.769 8.305C17.6729 8.20843 17.5587 8.13179 17.4329 8.0795C17.3071 8.02721 17.1722 8.00029 17.036 8.00029C16.8998 8.00029 16.7649 8.02721 16.6391 8.0795C16.5133 8.13179 16.3991 8.20843 16.303 8.305C16.1082 8.50162 15.9989 8.76721 15.9989 9.044C15.9989 9.32078 16.1082 9.58637 16.303 9.783L18.5 11.999L16.303 14.217C16.1085 14.4136 15.9994 14.679 15.9994 14.9555C15.9994 15.232 16.1085 15.4974 16.303 15.694C16.399 15.7907 16.5132 15.8674 16.639 15.9198C16.7648 15.9722 16.8997 15.9991 17.036 15.9991C17.1723 15.9991 17.3072 15.9722 17.433 15.9198C17.5588 15.8674 17.673 15.7907 17.769 15.694ZM12 21L12 19L5 19L5 5L12 5L12 3L4.994 3C3.894 3 3 3.893 3 4.995L3 19.005C2.99974 19.267 3.05112 19.5264 3.15123 19.7685C3.25133 20.0106 3.39818 20.2306 3.58338 20.4159C3.76858 20.6012 3.98849 20.7482 4.23054 20.8484C4.47259 20.9486 4.73202 21.0001 4.994 21L12 21Z",
    fill: "#D13D3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.458f9a91200194504878f6c87d1e6b67.svg";
export { ForwardRef as ReactComponent };